import React from "react";
import { useLocation } from "react-router-dom";

import Pages from "../routes/Pages";
import AdminLayout from "../../admin/shared/layout/AdminLayout";

import classes from "./Layout.module.css";

const Layout = () => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className={classes["content-wrapper"]}>
      {pathname.includes("admin-panel") ? (
        <AdminLayout />
      ) : pathname.includes("student-panel") ? (
        <AdminLayout />
      ) : (
        <Pages />
      )}
    </div>
  );
};

export default Layout;
